import { render, staticRenderFns } from "./detalhes-viagens.vue?vue&type=template&id=84b4e4ca&scoped=true&"
import script from "./detalhes-viagens.vue?vue&type=script&lang=js&"
export * from "./detalhes-viagens.vue?vue&type=script&lang=js&"
import style0 from "../styles/report.scss?vue&type=style&index=0&id=84b4e4ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b4e4ca",
  null
  
)

export default component.exports